export enum IssueType {
  STATIONARY_FOR_SIGNIFICANT_PERIOD_OF_TIME = 'Has been stationary for a significant period of time',
  BADLY_PARKED = 'Is badly parked or causing an obstruction',
  DAMAGED = 'Is damaged or vandalised',
  UNROADWORTHY = 'Is unroadworthy (flat tyres, wheels removed or broken windows)',
  MISSING_NUMBER_PLATES = 'Is missing both number plates (also known as registration plates)',
  BURNT_OUT = 'Is burnt out',
  NONE_OF_THE_ABOVE = 'None of the above',
}

export const getIssueTypeApiValue = (issueType: IssueType | null): string => {
  switch (issueType) {
    case IssueType.STATIONARY_FOR_SIGNIFICANT_PERIOD_OF_TIME:
      return 'Stationary';
    case IssueType.BADLY_PARKED:
      return 'Obstruction';
    case IssueType.DAMAGED:
      return 'DamagedVandalised';
    case IssueType.UNROADWORTHY:
      return 'Unroadworthy';
    case IssueType.MISSING_NUMBER_PLATES:
      return 'MissingRegistrationPlates';
    case IssueType.BURNT_OUT:
      return 'BurntOut';
    case IssueType.NONE_OF_THE_ABOVE:
      return 'NoneOfAbove';
    default:
      return '';
  }
};

export enum IssueLength {
  LESS_THAN_A_WEEK = 'Less than a week',
  '1_TO_2_WEEKS' = '1 to 2 weeks',
  '2_TO_4_WEEKS' = '2 to 4 weeks',
  MORE_THAN_A_MONTH = 'More than a month',
  NOT_SURE = 'Not sure',
}

export const getIssueLengthApiValue = (
  issueLength: IssueLength | null,
): string => {
  switch (issueLength) {
    case IssueLength.LESS_THAN_A_WEEK:
      return 'LessThanAWeek';
    case IssueLength['1_TO_2_WEEKS']:
      return 'OneToTwoWeeks';
    case IssueLength['2_TO_4_WEEKS']:
      return 'TwoToFourWeeks';
    case IssueLength.MORE_THAN_A_MONTH:
      return 'MoreThanAMonth';
    case IssueLength.NOT_SURE:
      return 'NotSure';
    default:
      return '';
  }
};
